// extracted by mini-css-extract-plugin
export default {"container":"ParaInput_container__ZAqr8"};